import AnnotationsHandler from '..';

AnnotationsHandler.registerHandler('@LR', (value: string) => {
  return value;
});
